import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import StoryBeginningCard, { StoryForwardCard, StorySimorghCard, StoryTruthCard } from "./StoryCard";
import laptopImg from "../../Assets/robot_birds.jpg";
import syepMain from "../../Assets/syepMain.png";
import cf2025 from "../../Assets/syep_2025.jpeg";
import cfCommunity1 from "../../Assets/cf-community-1.png";
import cfCommunity2 from "../../Assets/cf-community-2.png";
import cfCommunity3 from "../../Assets/cf-community-3.png";
import cfCommunity4 from "../../Assets/cf-community-4.png";
import cfCommunity6 from "../../Assets/cf-community-6.png";
import cfCommunity7 from "../../Assets/cf-community-7.png";
import cfCommunity8 from "../../Assets/cf-community-8.png";
import cfCommunity9 from "../../Assets/cf-community-9.png";
import cfCommunity10 from "../../Assets/cf-community-10.png";

import { Trans, useTranslation } from "react-i18next";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";




function Story() {
  const { t } = useTranslation();

  const [activeSlide, setActiveSlide] = React.useState(0);

  const sliderImages = [
    
    { src: cfCommunity1, altKey: "aboutWho.sliderAlts.2" },
    { src: syepMain, altKey: "aboutWho.sliderAlts.0" },
    { src: cfCommunity6, altKey: "aboutWho.sliderAlts.7" },
    { src: cfCommunity2, altKey: "aboutWho.sliderAlts.3" },
    { src: cfCommunity3, altKey: "aboutWho.sliderAlts.4" },
    { src: cf2025, altKey: "aboutWho.sliderAlts.1" },
    { src: cfCommunity4, altKey: "aboutWho.sliderAlts.5" },
    { src: cfCommunity7, altKey: "aboutWho.sliderAlts.8" },
    { src: cfCommunity8, altKey: "aboutWho.sliderAlts.9" },
    { src: cfCommunity9, altKey: "aboutWho.sliderAlts.10" },
    { src: cfCommunity10, altKey: "aboutWho.sliderAlts.11" },
    { src: laptopImg, altKey: "story.sliderAlts.0" },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2400,
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: false,
    lazyLoad: "ondemand",
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  return (
    <Container fluid className="about-section story-page">
      <Particle />
      <Container className="story-container">
        <header className="story-hero">
          <h1 className="story-hero-title">
            <Trans i18nKey="story.hero.title" components={{ purple: <strong className="purple" /> }} />
          </h1>
          <p className="story-hero-lead">
            {t("story.hero.lead")}
          </p>
        </header>

        <Row className="about-top">
          <Col xs={12} md={6} className="about-top-col">
            <h2 className="about-section-heading about-section-heading--ghost" aria-hidden="true">
              <Trans i18nKey="story.hero.title" components={{ purple: <span className="purple" /> }} />
            </h2>
            <StoryBeginningCard />
          </Col>

          <Col xs={12} md={6} className="about-top-col">
            <h2 className="about-section-heading about-section-heading--ghost" aria-hidden="true">
              <Trans i18nKey="story.hero.title" components={{ purple: <span className="purple" /> }} />
            </h2>
            <div
              className="policy-card mission-image-card mission-slider-card mission-top-media-card about-top-media-card"
              aria-label={t("story.image.alt")}
            >
              <Slider {...sliderSettings}>
                {sliderImages.map((image, index) => (
                  <div key={index} className="mission-slide">
                    <SlickLazyImage
                      src={image.src}
                      alt={t(image.altKey)}
                      className="mission-slide-img"
                      index={index}
                      activeIndex={activeSlide}
                      total={sliderImages.length}
                      buffer={2}
                      eager
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>

        <Row className="story-details" xs={1} md={2} style={{ justifyContent: "center" }}>
          <Col className="story-details-col">
            <StorySimorghCard />
          </Col>
          <Col className="story-details-col">
            <StoryTruthCard />
          </Col>
        </Row>

        <Row className="story-details story-details--single" style={{ justifyContent: "center" }}>
          <Col md={12} className="story-details-col">
            <StoryForwardCard />
          </Col>
        </Row>

        <h2 className="story-section-heading">
          <Trans i18nKey="story.journey.heading" components={{ purple: <strong className="purple" /> }} />
        </h2>

        <p className="story-section-lead">
          {t("story.journey.lead")}
        </p>

        <Techstack />
      </Container>
    </Container>
  );
}

export default Story;
